import classNames from "classnames/bind";
import React from "react";
import KeyValueTile from "./KeyValueTile";
import styles from "./KeyValueTileGrid.module.scss";
import type { KeyValueTileGridProps } from "./types";

const cx = classNames.bind(styles);

/**
 * A grid layout container for Key Value Tiles that can lay them out fluidly or evenly.
 */
const KeyValueTileGrid = ({
  data,
  layout = "masonry",
  isLoading,
  className,
  style,
}: KeyValueTileGridProps) => {
  return (
    <div
      className={cx("container", layout, className)}
      style={style}
    >
      {data.map(({ title, value, ...rest }, idx) => (
        <KeyValueTile
          key={`${value}-${idx}`}
          title={title}
          value={value}
          {...(isLoading ? { isLoading } : {})}
          {...rest}
        />
      ))}
    </div>
  );
};

export default KeyValueTileGrid;
